import { getTreeIndex } from "routes/schedule/lib/getTreeIndex"

export function getTreeItemRetriever() {
    const index = getTreeIndex()
    return function getItem(id, hint) {
        return index.retrieve(id, hint)
    }
}
